import React from 'react';
import { SubProductUpdater } from '@atlassian/jira-spa-apps-common/src/analytics-sub-product/sub-product-updater/index.tsx';
import SpaErrorBoundary from '@atlassian/jira-spa-apps-common/src/error-boundary';
import { AuthenticationCheck } from '@atlassian/jira-spa-apps-common/src/interceptors/authentication';
import { MarkProductStart } from '@atlassian/jira-spa-performance-breakdown/src/utils/mark-product-start/index.tsx';
import CompassProductSettingsPage from './ui';

const CompassProductSettingsSPAContainer = () => (
	<>
		<MarkProductStart />
		<SpaErrorBoundary id="spa-app-bootstrap.jira-compass-product-settings">
			<SubProductUpdater subProduct="software" />
			<AuthenticationCheck>
				<CompassProductSettingsPage />
			</AuthenticationCheck>
		</SpaErrorBoundary>
	</>
);

export default CompassProductSettingsSPAContainer;
